import { render, staticRenderFns } from "./InquiryDetail.vue?vue&type=template&id=0b24e4c3&scoped=true&"
import script from "./InquiryDetail.vue?vue&type=script&lang=js&"
export * from "./InquiryDetail.vue?vue&type=script&lang=js&"
import style0 from "./InquiryDetail.vue?vue&type=style&index=0&id=0b24e4c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b24e4c3",
  null
  
)

export default component.exports